import { render, staticRenderFns } from "./coperForm.vue?vue&type=template&id=fd6a7048&scoped=true&"
import script from "./coperForm.vue?vue&type=script&lang=js&"
export * from "./coperForm.vue?vue&type=script&lang=js&"
import style0 from "./coperForm.vue?vue&type=style&index=0&id=fd6a7048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6a7048",
  null
  
)

export default component.exports